import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const HeadlineOrderTwo = styled.h2<{ isBold?: boolean; color?: string }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: 24px;
  line-height: 36px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
  @media ${device.laptop} {
    font-size: 28px;
    line-height: 44px;
  }
  @media ${device.laptopL} {
    font-size: 32px;
    line-height: 48px;
  }
  @media ${device.desktop} {
    font-size: 36px;
    line-height: 52px;
  }
`;
